<div class="page--padder"></div>
@if (post) {
  <section class="grid-x">
    <div class="container">
      <div class="blog__content grid-x">
        <div class="cell large-12">
          <h1 class="center-text">{{post.attributes.title}}</h1>
        </div>
        <div class="cell large-12">
          <div class="blog__image" [ngStyle]="{'background-image': 'url(' + (image | async) + ')'}"></div>
        </div>
        <div class="cell large-12">
          <p class="center-text">{{post.attributes.summary}}</p>
        </div>
        <div class="cell large-12">
          <quill-view-html class="quill-html" [content]="post.attributes.content"></quill-view-html>
        </div>
      </div>
    </div>
  </section>
}
